import { WSEmptyState } from "@wingspanhq/fe-component-library";
import { openInNewTab } from "../../../shared/utils/openInNewTab";
import { WS_LINKS } from "../../../types/wsLinks";
import React from "react";

export const RequirementsEmptyState: React.FC<{}> = () => {
  return (
    <WSEmptyState
      type="tasks"
      title="No requirements active"
      description="Once a requirement is added and active, it will appear here."
      actions={{
        buttons: [
          {
            label: "Learn more",
            kind: "Link",
            onClick: () => openInNewTab(WS_LINKS.engagements)
          }
        ]
      }}
    />
  );
};
